import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { reducerCartClear } from '../../store/Cart/CartReducer';
import { useAppDispatch } from '../../store/hooks';

export default function HomeClearCart() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(reducerCartClear())
        navigate('/')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <></>
    );
}